/**
 * 10.9IT — CONTA SUSPENSA. Tela cheia, sem botão de fechar: quem foi banido pelo painel de
 * administração vê o motivo e até quando, e não entra no mundo. A checagem é feita ao tocar em
 * Jogar (Game.play), tolerante a rede: sem resposta, o jogo segue normal.
 */
import { i18n } from "../i18n/i18n";
import type { Ban } from "../net/AdminGrants";

export class BanScreen {
  private readonly root: HTMLDivElement;

  constructor(uiRoot: HTMLElement) {
    this.root = document.createElement("div");
    this.root.className = "overlay ban-overlay";
    this.root.hidden = true;
    uiRoot.appendChild(this.root);
  }

  show(b: Ban): void {
    const esc = (t: string): string => t.replace(/[&<>]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;" })[c]!);
    const ate = b.until ? i18n.t("ban.until", { date: new Date(b.until).toLocaleString() }) : i18n.t("ban.perm");
    this.root.innerHTML = `<div class="panel void-panel ban-panel">
      <h2>${esc(i18n.t("ban.title"))}</h2>
      <p class="ban-body">${esc(i18n.t("ban.body"))}</p>
      ${b.reason ? `<p class="ban-reason">${esc(b.reason)}</p>` : ""}
      <p class="ban-until">${esc(ate)}</p>
    </div>`;
    this.root.hidden = false;
  }

  hide(): void {
    this.root.hidden = true;
  }
}
